// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"c6a1be46","496":"08b8c779","754":"3aa9aa51","756":"e0bd7da0","909":"8581f765","937":"acf4fb4c"}[chunkId] + ".chunk.js";
};